// Bundled list of major world cities for the onboarding autocomplete.
// Shape: { city, region, country, regionCode }
// regionCode is shown in the UI next to the city (e.g. "Calgary, AB").
export const CITIES = [
    { city: "Lagos", region: "Lagos State", regionCode: "LA", country: "Nigeria" },
    { city: "Abuja", region: "FCT", regionCode: "FC", country: "Nigeria" },
    { city: "Nairobi", region: "Nairobi County", regionCode: "NA", country: "Kenya" },
    { city: "Mombasa", region: "Mombasa County", regionCode: "MB", country: "Kenya" },
    { city: "Cape Town", region: "Western Cape", regionCode: "WC", country: "South Africa" },
    { city: "Johannesburg", region: "Gauteng", regionCode: "GP", country: "South Africa" },
    { city: "Durban", region: "KwaZulu-Natal", regionCode: "KZN", country: "South Africa" },
    { city: "Accra", region: "Greater Accra", regionCode: "GA", country: "Ghana" },
    { city: "Cairo", region: "Cairo Governorate", regionCode: "C", country: "Egypt" },
    { city: "Alexandria", region: "Alexandria Governorate", regionCode: "ALX", country: "Egypt" },
    { city: "Casablanca", region: "Casablanca-Settat", regionCode: "CAS", country: "Morocco" },
    { city: "Marrakech", region: "Marrakech-Safi", regionCode: "MAR", country: "Morocco" },
    { city: "Tunis", region: "Tunis Governorate", regionCode: "TU", country: "Tunisia" },
    { city: "Algiers", region: "Algiers Province", regionCode: "ALG", country: "Algeria" },
    { city: "Addis Ababa", region: "Addis Ababa", regionCode: "AA", country: "Ethiopia" },
    { city: "Kampala", region: "Central Region", regionCode: "KLA", country: "Uganda" },
    { city: "Dar es Salaam", region: "Dar es Salaam", regionCode: "DSM", country: "Tanzania" },
    { city: "Kigali", region: "Kigali", regionCode: "KGL", country: "Rwanda" },

    { city: "London", region: "England", regionCode: "ENG", country: "United Kingdom" },
    { city: "Manchester", region: "England", regionCode: "ENG", country: "United Kingdom" },
    { city: "Birmingham", region: "England", regionCode: "ENG", country: "United Kingdom" },
    { city: "Edinburgh", region: "Scotland", regionCode: "SCT", country: "United Kingdom" },
    { city: "Glasgow", region: "Scotland", regionCode: "SCT", country: "United Kingdom" },
    { city: "Dublin", region: "Leinster", regionCode: "L", country: "Ireland" },
    { city: "Paris", region: "Île-de-France", regionCode: "IDF", country: "France" },
    { city: "Lyon", region: "Auvergne-Rhône-Alpes", regionCode: "ARA", country: "France" },
    { city: "Marseille", region: "Provence-Alpes-Côte d'Azur", regionCode: "PACA", country: "France" },
    { city: "Berlin", region: "Berlin", regionCode: "BE", country: "Germany" },
    { city: "Munich", region: "Bavaria", regionCode: "BY", country: "Germany" },
    { city: "Hamburg", region: "Hamburg", regionCode: "HH", country: "Germany" },
    { city: "Frankfurt", region: "Hesse", regionCode: "HE", country: "Germany" },
    { city: "Amsterdam", region: "North Holland", regionCode: "NH", country: "Netherlands" },
    { city: "Rotterdam", region: "South Holland", regionCode: "ZH", country: "Netherlands" },
    { city: "Brussels", region: "Brussels Capital", regionCode: "BRU", country: "Belgium" },
    { city: "Madrid", region: "Community of Madrid", regionCode: "MD", country: "Spain" },
    { city: "Barcelona", region: "Catalonia", regionCode: "CT", country: "Spain" },
    { city: "Valencia", region: "Valencia", regionCode: "VC", country: "Spain" },
    { city: "Lisbon", region: "Lisbon", regionCode: "LI", country: "Portugal" },
    { city: "Porto", region: "Porto", regionCode: "PO", country: "Portugal" },
    { city: "Rome", region: "Lazio", regionCode: "LZ", country: "Italy" },
    { city: "Milan", region: "Lombardy", regionCode: "LO", country: "Italy" },
    { city: "Naples", region: "Campania", regionCode: "CA", country: "Italy" },
    { city: "Zurich", region: "Zurich", regionCode: "ZH", country: "Switzerland" },
    { city: "Geneva", region: "Geneva", regionCode: "GE", country: "Switzerland" },
    { city: "Vienna", region: "Vienna", regionCode: "W", country: "Austria" },
    { city: "Copenhagen", region: "Capital Region", regionCode: "DK-84", country: "Denmark" },
    { city: "Stockholm", region: "Stockholm County", regionCode: "AB", country: "Sweden" },
    { city: "Oslo", region: "Oslo", regionCode: "03", country: "Norway" },
    { city: "Helsinki", region: "Uusimaa", regionCode: "US", country: "Finland" },
    { city: "Warsaw", region: "Masovian", regionCode: "MZ", country: "Poland" },
    { city: "Krakow", region: "Lesser Poland", regionCode: "MA", country: "Poland" },
    { city: "Prague", region: "Prague", regionCode: "PR", country: "Czechia" },
    { city: "Budapest", region: "Budapest", regionCode: "BU", country: "Hungary" },
    { city: "Athens", region: "Attica", regionCode: "I", country: "Greece" },
    { city: "Istanbul", region: "Istanbul", regionCode: "34", country: "Turkey" },
    { city: "Ankara", region: "Ankara", regionCode: "06", country: "Turkey" },

    { city: "New York", region: "New York", regionCode: "NY", country: "United States" },
    { city: "Brooklyn", region: "New York", regionCode: "NY", country: "United States" },
    { city: "Los Angeles", region: "California", regionCode: "CA", country: "United States" },
    { city: "San Francisco", region: "California", regionCode: "CA", country: "United States" },
    { city: "San Diego", region: "California", regionCode: "CA", country: "United States" },
    { city: "Chicago", region: "Illinois", regionCode: "IL", country: "United States" },
    { city: "Houston", region: "Texas", regionCode: "TX", country: "United States" },
    { city: "Austin", region: "Texas", regionCode: "TX", country: "United States" },
    { city: "Dallas", region: "Texas", regionCode: "TX", country: "United States" },
    { city: "Miami", region: "Florida", regionCode: "FL", country: "United States" },
    { city: "Orlando", region: "Florida", regionCode: "FL", country: "United States" },
    { city: "Atlanta", region: "Georgia", regionCode: "GA", country: "United States" },
    { city: "Seattle", region: "Washington", regionCode: "WA", country: "United States" },
    { city: "Portland", region: "Oregon", regionCode: "OR", country: "United States" },
    { city: "Boston", region: "Massachusetts", regionCode: "MA", country: "United States" },
    { city: "Washington", region: "District of Columbia", regionCode: "DC", country: "United States" },
    { city: "Philadelphia", region: "Pennsylvania", regionCode: "PA", country: "United States" },
    { city: "Phoenix", region: "Arizona", regionCode: "AZ", country: "United States" },
    { city: "Denver", region: "Colorado", regionCode: "CO", country: "United States" },
    { city: "Las Vegas", region: "Nevada", regionCode: "NV", country: "United States" },
    { city: "Nashville", region: "Tennessee", regionCode: "TN", country: "United States" },
    { city: "Detroit", region: "Michigan", regionCode: "MI", country: "United States" },
    { city: "Minneapolis", region: "Minnesota", regionCode: "MN", country: "United States" },
    { city: "New Orleans", region: "Louisiana", regionCode: "LA", country: "United States" },
    { city: "Honolulu", region: "Hawaii", regionCode: "HI", country: "United States" },

    { city: "Toronto", region: "Ontario", regionCode: "ON", country: "Canada" },
    { city: "Ottawa", region: "Ontario", regionCode: "ON", country: "Canada" },
    { city: "Montreal", region: "Quebec", regionCode: "QC", country: "Canada" },
    { city: "Quebec City", region: "Quebec", regionCode: "QC", country: "Canada" },
    { city: "Vancouver", region: "British Columbia", regionCode: "BC", country: "Canada" },
    { city: "Victoria", region: "British Columbia", regionCode: "BC", country: "Canada" },
    { city: "Calgary", region: "Alberta", regionCode: "AB", country: "Canada" },
    { city: "Edmonton", region: "Alberta", regionCode: "AB", country: "Canada" },
    { city: "Winnipeg", region: "Manitoba", regionCode: "MB", country: "Canada" },
    { city: "Halifax", region: "Nova Scotia", regionCode: "NS", country: "Canada" },

    { city: "Mexico City", region: "Mexico City", regionCode: "CDMX", country: "Mexico" },
    { city: "Guadalajara", region: "Jalisco", regionCode: "JAL", country: "Mexico" },
    { city: "Monterrey", region: "Nuevo León", regionCode: "NLE", country: "Mexico" },
    { city: "Cancún", region: "Quintana Roo", regionCode: "QR", country: "Mexico" },

    { city: "São Paulo", region: "São Paulo", regionCode: "SP", country: "Brazil" },
    { city: "Rio de Janeiro", region: "Rio de Janeiro", regionCode: "RJ", country: "Brazil" },
    { city: "Brasília", region: "Federal District", regionCode: "DF", country: "Brazil" },
    { city: "Salvador", region: "Bahia", regionCode: "BA", country: "Brazil" },
    { city: "Belo Horizonte", region: "Minas Gerais", regionCode: "MG", country: "Brazil" },
    { city: "Buenos Aires", region: "Buenos Aires", regionCode: "B", country: "Argentina" },
    { city: "Córdoba", region: "Córdoba", regionCode: "X", country: "Argentina" },
    { city: "Santiago", region: "Santiago Metropolitan", regionCode: "RM", country: "Chile" },
    { city: "Lima", region: "Lima", regionCode: "LIM", country: "Peru" },
    { city: "Bogotá", region: "Bogotá", regionCode: "DC", country: "Colombia" },
    { city: "Medellín", region: "Antioquia", regionCode: "ANT", country: "Colombia" },
    { city: "Quito", region: "Pichincha", regionCode: "P", country: "Ecuador" },
    { city: "Caracas", region: "Capital District", regionCode: "A", country: "Venezuela" },
    { city: "Montevideo", region: "Montevideo", regionCode: "MO", country: "Uruguay" },

    { city: "Dubai", region: "Dubai", regionCode: "DU", country: "United Arab Emirates" },
    { city: "Abu Dhabi", region: "Abu Dhabi", regionCode: "AZ", country: "United Arab Emirates" },
    { city: "Sharjah", region: "Sharjah", regionCode: "SH", country: "United Arab Emirates" },
    { city: "Riyadh", region: "Riyadh", regionCode: "01", country: "Saudi Arabia" },
    { city: "Jeddah", region: "Makkah", regionCode: "02", country: "Saudi Arabia" },
    { city: "Doha", region: "Doha", regionCode: "DA", country: "Qatar" },
    { city: "Kuwait City", region: "Al Asimah", regionCode: "KU", country: "Kuwait" },
    { city: "Manama", region: "Capital Governorate", regionCode: "13", country: "Bahrain" },
    { city: "Muscat", region: "Muscat", regionCode: "MA", country: "Oman" },
    { city: "Amman", region: "Amman", regionCode: "AM", country: "Jordan" },
    { city: "Beirut", region: "Beirut", regionCode: "BA", country: "Lebanon" },
    { city: "Tel Aviv", region: "Tel Aviv District", regionCode: "TA", country: "Israel" },
    { city: "Jerusalem", region: "Jerusalem District", regionCode: "JM", country: "Israel" },
    { city: "Tehran", region: "Tehran", regionCode: "TEH", country: "Iran" },
    { city: "Baghdad", region: "Baghdad", regionCode: "BG", country: "Iraq" },

    { city: "Delhi", region: "Delhi", regionCode: "DL", country: "India" },
    { city: "Mumbai", region: "Maharashtra", regionCode: "MH", country: "India" },
    { city: "Bengaluru", region: "Karnataka", regionCode: "KA", country: "India" },
    { city: "Chennai", region: "Tamil Nadu", regionCode: "TN", country: "India" },
    { city: "Hyderabad", region: "Telangana", regionCode: "TG", country: "India" },
    { city: "Kolkata", region: "West Bengal", regionCode: "WB", country: "India" },
    { city: "Pune", region: "Maharashtra", regionCode: "MH", country: "India" },
    { city: "Ahmedabad", region: "Gujarat", regionCode: "GJ", country: "India" },
    { city: "Jaipur", region: "Rajasthan", regionCode: "RJ", country: "India" },
    { city: "Goa", region: "Goa", regionCode: "GA", country: "India" },
    { city: "Karachi", region: "Sindh", regionCode: "SD", country: "Pakistan" },
    { city: "Lahore", region: "Punjab", regionCode: "PB", country: "Pakistan" },
    { city: "Islamabad", region: "Islamabad Capital Territory", regionCode: "IS", country: "Pakistan" },
    { city: "Dhaka", region: "Dhaka Division", regionCode: "C", country: "Bangladesh" },
    { city: "Colombo", region: "Western Province", regionCode: "1", country: "Sri Lanka" },
    { city: "Kathmandu", region: "Bagmati", regionCode: "BA", country: "Nepal" },

    { city: "Beijing", region: "Beijing", regionCode: "BJ", country: "China" },
    { city: "Shanghai", region: "Shanghai", regionCode: "SH", country: "China" },
    { city: "Guangzhou", region: "Guangdong", regionCode: "GD", country: "China" },
    { city: "Shenzhen", region: "Guangdong", regionCode: "GD", country: "China" },
    { city: "Chengdu", region: "Sichuan", regionCode: "SC", country: "China" },
    { city: "Hong Kong", region: "Hong Kong", regionCode: "HK", country: "Hong Kong SAR" },
    { city: "Taipei", region: "Taipei", regionCode: "TPE", country: "Taiwan" },
    { city: "Tokyo", region: "Tokyo", regionCode: "13", country: "Japan" },
    { city: "Osaka", region: "Osaka", regionCode: "27", country: "Japan" },
    { city: "Kyoto", region: "Kyoto", regionCode: "26", country: "Japan" },
    { city: "Yokohama", region: "Kanagawa", regionCode: "14", country: "Japan" },
    { city: "Seoul", region: "Seoul", regionCode: "11", country: "South Korea" },
    { city: "Busan", region: "Busan", regionCode: "26", country: "South Korea" },
    { city: "Singapore", region: "Singapore", regionCode: "SG", country: "Singapore" },
    { city: "Kuala Lumpur", region: "Federal Territory", regionCode: "14", country: "Malaysia" },
    { city: "Bangkok", region: "Bangkok", regionCode: "10", country: "Thailand" },
    { city: "Chiang Mai", region: "Chiang Mai", regionCode: "50", country: "Thailand" },
    { city: "Hanoi", region: "Hanoi", regionCode: "HN", country: "Vietnam" },
    { city: "Ho Chi Minh City", region: "Ho Chi Minh", regionCode: "SG", country: "Vietnam" },
    { city: "Manila", region: "Metro Manila", regionCode: "00", country: "Philippines" },
    { city: "Jakarta", region: "Jakarta", regionCode: "JK", country: "Indonesia" },
    { city: "Bali", region: "Bali", regionCode: "BA", country: "Indonesia" },

    { city: "Sydney", region: "New South Wales", regionCode: "NSW", country: "Australia" },
    { city: "Melbourne", region: "Victoria", regionCode: "VIC", country: "Australia" },
    { city: "Brisbane", region: "Queensland", regionCode: "QLD", country: "Australia" },
    { city: "Perth", region: "Western Australia", regionCode: "WA", country: "Australia" },
    { city: "Adelaide", region: "South Australia", regionCode: "SA", country: "Australia" },
    { city: "Canberra", region: "Australian Capital Territory", regionCode: "ACT", country: "Australia" },
    { city: "Auckland", region: "Auckland", regionCode: "AUK", country: "New Zealand" },
    { city: "Wellington", region: "Wellington", regionCode: "WGN", country: "New Zealand" },

    { city: "Moscow", region: "Moscow", regionCode: "MOW", country: "Russia" },
    { city: "Saint Petersburg", region: "Saint Petersburg", regionCode: "SPE", country: "Russia" },
    { city: "Kyiv", region: "Kyiv", regionCode: "30", country: "Ukraine" },
];

export function formatCityLabel(entry) {
    if (!entry) return "";
    const regionBit = entry.regionCode || entry.region;
    return regionBit ? `${entry.city}, ${regionBit}` : entry.city;
}
